<template>
<div>
 
  <div class="page-header d-flex w-100 pt-3">
    <div class="title-col d-flex">
      <span class="title-icon">
        <b-icon-folder-fill></b-icon-folder-fill>
      </span>
      <!-- {{gridInfoData.data}} -->
      <span class="title-text">{{gridInfoData.name}}</span>
    </div>
     <div class="text-right d-flex ml-auto">
       <button class="btn btn-icon tooltip" @click="callCustomMethod">
        <span class="nt-file-text"></span>
        <span class="tooltiptext">Export</span>
      </button>
      <kendo-button
        class="k-button k-primary ml-2"
        @click="back"
        >Back</kendo-button
      >
     </div>  
     
  </div>
  <div class="page-body loading ">
    <CustomGrid  :isTimeformat='isTimeformat' :jsonObject="gridInfoData.configuration" :gridInfoData="gridInfoData" :baseUrl="urlJson" :reportServiceChannelKey="reportServiceChannelKey" 
    :summaryReportCols="getSummaryCols" :summaryConfig="summaryReport" ref="customRef"></CustomGrid>
  </div>
</div>
  
</template>

<script>

import CustomGrid from "@/components/Reports/CustomGrid"
import { createNamespacedHelpers } from "vuex";
const { mapState} = createNamespacedHelpers("dynamicReport");
export default {
  name: "App",
  components: {
    CustomGrid,
  },

  data() {
    return {
     
    };
  },
  methods:{
    back(){
      this.$router.push({name:"Reports"})
    },
    callCustomMethod(){
       this.$refs.customRef.exportExcel()
    }
  },

  computed: {
     ...mapState(["gridInfoData","urlJson","reportServiceChannelKey", "summaryReport"]),
   
    dataSource() {
      return this.grid.kendo.dataSource;
    },
     isTimeformat(){
       return this.$store.state.isTimeFormat
     },
     getSummaryCols(){
       if(this.summaryReport && this.summaryReport.configuration && this.summaryReport.configuration.columns){
        return this.summaryReport.configuration.columns;
      }
        else return [];
      }
    }
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
  margin-top: 60px;
} */
</style>
